/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 2/8/2023
 */


import React from 'react'
import { Button, Grid, Paper, TextField, Typography } from '@mui/material'
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useNavigate } from 'react-router-dom';

import { useSendResetPWEmailMutation } from '../Store/Services/AuthService';

import styles from "./ForgotPassword.module.css"

const schema = yup.object().shape({
    email: yup.string()
        .trim()
        .email("Please provide a valid Email!")
        .required("Please enter Email "),
});

const ForgotPassword = () => {

    const navigate = useNavigate()

    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(schema),
    });

    const [ restPassword ] = useSendResetPWEmailMutation();

    const submit = async (data) => {
        try {
            const result = await restPassword(data).unwrap();
            navigate(`/reset-password/${result.token}/${result.email}`);
        } catch (err) {
            console.error(err);
            // toast.error("Erorr, something went wrong!");
        }
    }

    return (
        <div className={styles.container}>
            <Paper className={styles.paper}>
                <Typography variant="h5" textAlign="center" fontWeight="bold">Forgot your password?</Typography>
                <Typography textAlign="center" color="text.secondary" mt={1}>
                    Please enter your email address.<br/> You will receive a link to create a new password via email.
                </Typography>
                <form onSubmit={handleSubmit(submit)}>
                    <div className={styles.formItem}>
                        <label className={styles.formLabel}>Email:</label>
                        <TextField
                            {...register("email")}
                            className={styles.formText}
                            placeholder="Enter email address"
                            size='small'
                            fullWidth
                            error={!!errors.email}
                            helperText={errors.email?.message}
                        />
                    </div>
                    <div className={styles.formItem}>
                        <Button type="submit" variant='contained' fullWidth>Send Email</Button>
                    </div>
                </form>
            </Paper>
        </div>
    )
}

export default ForgotPassword